import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { authorizationGuard } from 'src/guards/authorization.guard';

const masterUsersRtm = ['RTM_MASTER', 'BRSA_ASSIST_SCANIA_IT'];
const allUsersRtm    = [...masterUsersRtm, 'RTM_USER'];
const masterUsersCpm = ['CPM_MASTER', 'BRSA_ASSIST_SCANIA_IT'];
const allUsersCpm    = [...masterUsersCpm, 'CPM_USER'];
const masterUsers    = [...new Set([...masterUsersRtm, ...masterUsersCpm])];

export const routes: Routes = [
  // rota de callback do MSAL
  { path: 'auth', loadComponent: () => import('@azure/msal-angular').then(m => m.MsalRedirectComponent) },

  { path: '', pathMatch: 'full', redirectTo: 'home' },

  { path: 'home',
    canActivate: [MsalGuard, authorizationGuard],
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
  },

  { path: 'users',
    canActivate: [MsalGuard, authorizationGuard],
    data: { allowedRoles: masterUsers },
    loadComponent: () => import('./settings/users/users.component').then(m => m.UsersComponent),
  },

  { path: 'access-denied',
    loadComponent: () => import('./shared/components/layout/access-denied/access-denied.component')
      .then(m => m.AccessDeniedComponent),
  },

  // RTM
  { path: 'real-time-management/create',
    canActivate: [MsalGuard, authorizationGuard],
    data: { allowedRoles: allUsersRtm },
    loadComponent: () => import('./real-time-management/real-time-management-form/real-time-management-form.component')
      .then(m => m.RealTimeManagementFormComponent),
  },
  { path: 'real-time-management/edit',
    canActivate: [MsalGuard, authorizationGuard],
    data: { allowedRoles: allUsersRtm },
    loadComponent: () => import('./real-time-management/real-time-management-form/real-time-management-form.component')
      .then(m => m.RealTimeManagementFormComponent),
  },
  { path: 'real-time-management/setup',
    canActivate: [MsalGuard, authorizationGuard],
    data: { allowedRoles: masterUsersRtm },
    loadComponent: () => import('./real-time-management/real-time-management-setup/real-time-management-setup.component')
      .then(m => m.RealTimeManagementSetupComponent),
  },
  { path: 'real-time-management/search',
    canActivate: [MsalGuard, authorizationGuard],
    data: { allowedRoles: allUsersRtm },
    loadComponent: () => import('./real-time-management/real-time-management-search/real-time-management-search.component')
      .then(m => m.RealTimeManagementSearchComponent),
  },

  // CPM
  { path: 'change-point-management/create',
    canActivate: [MsalGuard, authorizationGuard],
    data: { allowedRoles: allUsersCpm },
    loadComponent: () => import('./change-point-management/change-point-management-form/change-point-management-form.component')
      .then(m => m.ChangePointManagementFormComponent),
  },
  { path: 'change-point-management/search',
    canActivate: [MsalGuard, authorizationGuard],
    data: { allowedRoles: allUsersCpm },
    loadComponent: () => import('./change-point-management/change-point-management-search/change-point-management-search.component')
      .then(m => m.ChangePointManagementSearchComponent),
  },
  { path: 'change-point-management/edit',
    canActivate: [MsalGuard, authorizationGuard],
    data: { allowedRoles: allUsersCpm },
    loadComponent: () => import('./change-point-management/change-point-management-form/change-point-management-form.component')
      .then(m => m.ChangePointManagementFormComponent),
  },
  { path: 'change-point-management/setup',
    canActivate: [MsalGuard, authorizationGuard],
    data: { allowedRoles: masterUsersCpm },
    loadComponent: () => import('./change-point-management/change-point-management-setup/change-point-management-setup.component')
      .then(m => m.ChangePointManagementSetupComponent),
  },

  { path: '**', redirectTo: 'home' },
];
